/**
 * @file Commonly used validations.
 */

const validateName = (str: string) => /^[a-z ,.'-]+$/i.test(str)

const validateAccountNumber = (str: string) => /^[0-9]{8}$/.test(str)

const validateSortCode = (str: string) => /^[0-9]{6}$/.test(str)

const validateRegPlate = (str: string) =>
  /^.*[0-9]+.*$/.test(str) && /^.*[a-zA-Z]+.*$/.test(str) && !/[$-/:-?{-~!"^_`[\]]/.test(str)

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.!,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const dateRegex = /^\d{4}-\d{2}-\d{2}$/

const postCodeRegex =
  /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/

/**
 * Validate date format and make sure it is a valid date
 * @link Based on: https://stackoverflow.com/a/35413963
 */
const validateDate = (str: string) => {
  const matchRegex = str.match(dateRegex)

  if (!matchRegex) {
    return false
  }

  const date = new Date(str)
  const valueInMs = date.getTime()
  if (!valueInMs && valueInMs !== 0) {
    return false
  }
  return date.toISOString().slice(0, 10) === str
}

const isEmptyString = (str?: string) => (!str ? true : !str.replace(/ /g, ''))

export {
  emailRegex,
  isEmptyString,
  postCodeRegex,
  validateAccountNumber,
  validateDate,
  validateName,
  validateRegPlate,
  validateSortCode,
}
